import { DefaultState } from 'store/types';

export const GET_BOOKINGS_BY_RESERVATIONS_REQUEST = 'GET_BOOKINGS_BY_RESERVATIONS_REQUEST';
export const GET_BOOKINGS_BY_RESERVATIONS_SUCCESS = 'GET_BOOKINGS_BY_RESERVATIONS_SUCCESS';
export const GET_BOOKINGS_BY_RESERVATIONS_FAILURE = 'GET_BOOKINGS_BY_RESERVATIONS_FAILURE';
export const SET_LOCATION_NAME = 'SET_LOCATION_NAME';

export interface GetBookingsByReservationsData {
  ids: string[];
  sorting: {
    id: string;
    order: string;
  }
}

export interface BookingByReservationsData {
  id: string;
  name: string;
  fromDate: string;
  toDate: string;
  gender: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
  lodgingOptionName: string;
  lodgingOptionType: string;
  lodgingOptionLikesCount: number;
}

export type GetBookingsByReservationsState = DefaultState & {
  contents?: BookingByReservationsData[];
  name: string,
};

interface GetBookingsByReservationsRequest {
  type: typeof GET_BOOKINGS_BY_RESERVATIONS_REQUEST;
  name: string;
}

interface GetBookingsByReservationsSuccess {
  type: typeof GET_BOOKINGS_BY_RESERVATIONS_SUCCESS,
  contents: BookingByReservationsData[];
  name: string;
}

interface GetBookingsByReservationsFailure {
  type: typeof GET_BOOKINGS_BY_RESERVATIONS_FAILURE;
  name: string;
}

interface SetReservationsAddress {
  type: typeof SET_LOCATION_NAME;
  name: string;
}

export type GetBookingsByReservationIdActionTypes = GetBookingsByReservationsRequest | GetBookingsByReservationsSuccess | GetBookingsByReservationsFailure | SetReservationsAddress;